import {useState} from 'react'
import {SearchBarContext} from './SearchBarContext'

export const SearchBarProvider = ({children}) => {
  const [search, setSearch] = useState('')

  return <SearchBarContext.Provider value={{search, setSearch}}>{children}</SearchBarContext.Provider>
}
